import type { PostiesConfig } from "~/lib/app/hooks";

export const FallbackPricing: PostiesConfig["pricing"] = {
  epaper: {
    annual: {
      intro: 40,
      rack: 79,
    },
    monthly: {
      intro: null,
      rack: 79,
    },
  },
  print: {
    annual: {
      intro: 57,
      rack: 92,
    },
    monthly: {
      intro: null,
      rack: 92,
    },
  },
};
